<div class="fcp-dropdown-tree" #container>
    <div
        class="fcp-dropdown-tree-container"
        [class.fcp-dropdown-tree-container-highlighted]="titleLabel().highlighted"
        [class.fcp-dropdown-tree-container-disabled]="disabled()"
        [ngClass]="{ 'fcp-dropdown-tree-container-open': isOpen() }"
        (click)="handleContainerClick()"
        data-e2e-hook="fcp-dropdown"
    >
        <div class="fcp-dropdown-tree-container-label">
            <fcp-icon
                *ngIf="titleIcon().show"
                class="fcp-dropdown-tree-container-label-icon"
                [icon]="['fal', titleIcon().value]"
            ></fcp-icon>
            <div
                class="fcp-dropdown-tree-container-label-text"
                [class.fcp-dropdown-tree-container-label-highlighted]="titleLabel().highlighted"
                [class.fcp-dropdown-tree-container-label-disabled]="disabled()"
            >
                {{ titleLabel().text }}
            </div>
        </div>
        <div class="fcp-dropdown-tree-container-suffix">
            <div class="fcp-dropdown-tree-container-badge" *ngIf="badgeText()">
                <fcp-badge
                    [text]="badgeText()"
                    [inversed]="badgeInversed()"
                    (mouseenter)="this.showBadgeTooltip = !this.showBadgeTooltip"
                    (mouseleave)="this.showBadgeTooltip = !this.showBadgeTooltip"
                    cdkOverlayOrigin
                    #badge="cdkOverlayOrigin"
                    ><fcp-icon
                        *ngIf="badgeIcon()"
                        [icon]="['fal', badgeIcon()]"
                        class="fcp-dropdown-tree-container-badge-icon"
                    ></fcp-icon
                ></fcp-badge>
                <fcp-tooltip
                    *ngIf="badgeTooltip()"
                    [open]="showBadgeTooltip"
                    [overlayOrigin]="badge"
                    [customPosition]="tooltipPosition"
                >
                    {{ badgeTooltip() }}
                </fcp-tooltip>
            </div>
            <div class="fcp-dropdown-tree-container-icon">
                <fcp-icon [icon]="['fal', 'chevron-down']"></fcp-icon>
            </div>
        </div>
    </div>

    <div class="fcp-dropdown-tree-menu" *ngIf="isOpen()">
        <div class="fcp-dropdown-tree-search-input" *ngIf="allowSearch()">
            <fcp-form-field width="fluid" [isInvalid]="false" [showErrorInline]="false">
                <fcp-icon fcpFieldPrefix [icon]="['fal', 'magnifying-glass']"></fcp-icon>
                <input
                    [attr.data-e2e-hook]="dataE2eHook()"
                    [placeholder]="searchTitle()"
                    (keyup)="handleSearchQueryChange($event.target.value)"
                    data-e2e-hook="fcp-dropdown-brand-search"
                    fcpInput
                />
            </fcp-form-field>
            <div class="fcp-dropdown-tree-search-not-found" *ngIf="filteredSections().length === 0">
                {{ notFoundMessage() }}
            </div>
        </div>
        <div class="fcp-dropdown-tree-menu-section-list">
            <ng-container *ngIf="hasMultiSelectToggle()">
                <span class="fcp-dropdown-tree-mode-toggle">
                    <fcp-toggle-switch
                        size="small"
                        [isActive]="isMultiSelectEnabled()"
                        (statusChange)="handleModeToggle()"
                    ></fcp-toggle-switch>
                    <span class="fcp-text-body-m">{{ toggleLabel() }}</span>
                </span>
                <hr class="fcp-dropdown-tree-menu-section-divider" />
            </ng-container>
            <ng-container *ngFor="let section of filteredSections()">
                <div
                    class="fcp-dropdown-tree-menu-section"
                    [ngClass]="{ 'fcp-dropdown-tree-menu-section-open': section.isOpen }"
                >
                    <div
                        class="fcp-dropdown-tree-menu-section-header"
                        *ngIf="section.label"
                        (click)="handleSectionClick(section)"
                    >
                        <div class="fcp-dropdown-tree-menu-section-header-icon" *ngIf="menu()?.isCollapsable">
                            <fcp-icon [icon]="['fal', 'chevron-right']"></fcp-icon>
                        </div>
                        <div class="fcp-dropdown-tree-menu-section-header-label">
                            {{ section.label }}
                        </div>
                    </div>
                    <div class="fcp-dropdown-tree-menu-section-list" *ngIf="section.isOpen || searchQuery()">
                        <ng-container *ngFor="let item of section.items">
                            <ng-container
                                [ngTemplateOutlet]="menuItem"
                                [ngTemplateOutletContext]="{ item }"
                            ></ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<ng-template let-item="item" #menuItem>
    <div
        class="fcp-dropdown-tree-menu-item"
        (click)="handleDropdownItemSelect(item)"
        [ngClass]="{ 'fcp-dropdown-tree-menu-item-selected': isDropdownItemSelected(item) }"
    >
        <div class="fcp-dropdown-tree-menu-item-label">
            <span>{{ item.label }}</span>
        </div>
        <div class="fcp-dropdown-tree-menu-item-suffix">
            <div class="fcp-dropdown-tree-menu-item-badge" *ngIf="item.badgeText">
                <fcp-badge [text]="item.badgeText" [inversed]="item.badgeInversed"
                    ><fcp-icon
                        *ngIf="item.badgeIcon"
                        [icon]="['fal', item.badgeIcon]"
                        class="fcp-dropdown-tree-menu-item-badge-icon"
                    ></fcp-icon
                ></fcp-badge>
            </div>
            <div class="fcp-dropdown-tree-menu-item-icon">
                <fcp-icon [icon]="['fal', 'check']" *ngIf="isDropdownItemSelected(item)"></fcp-icon>
            </div>
        </div>
    </div>
</ng-template>
